import { useState, useEffect, useRef } from "react";

import { API_URL, scroll, getValFromLS, fmtCurrency } from "../helpers";

import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import Input from "../components/Input";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

import AllocationsForm from "./AllocationsForm";
import Nav from "./Nav";

const Snapshot = () => {
	const [user, setUser] = useState({});
	const [details, setDetails] = useState({});
	const [results, setResults] = useState([]);
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({});
	const [msg, setMsg] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const formElement = useRef(null);

	useEffect(() => {
		const init = async () => {
			const token = getValFromLS("vtoUserToken")
				? getValFromLS("vtoUserToken")
				: "";
			const url = new URL(`${API_URL}/admin/snapshotInit`);
			const params = {
				token,
			};
			url.search = new URLSearchParams(params);

			try {
				const response = await fetch(url, {
					method: "GET",
					cache: "no-store",
				});
				const json = await response.json();
				if (json && json.resp === 1) {
					setUser({ ...json.user });
					setAlert({});
					scroll();
				} else {
					setAlert({
						type: json.resp === 2 ? "notice" : "error",
						text: json.text,
					});
				}
			} catch (error) {
				setAlert({
					type: "error",
					text: "An error has occurred.",
				});
			}
		};

		init();
	}, []);

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleSubmit = async (e = null, id = 0) => {
		if (e) {
			e.preventDefault();
		} else {
			formElement.current.registrationStr.value = id;
			handleUpdate("registrationStr", id);
			setResults([]);
		}
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});
		setDetails({});

		const url = new URL(`${API_URL}/admin/snapshot`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			if (key === "registrationStr" && id) {
				data.append(key, id);
			} else {
				data.append(key, value);
			}
		});
		data.append("fromSnapshotPage", "1");
		data.append("token", getValFromLS("vtoUserToken"));

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setMsg({
					type: "success",
					text: json.text,
				});

				setDetails({ ...json });
			} else if (json && json.resp === 2) {
				if (json.results.length === 1) {
					handleMatch(json.results[0].id);
				} else {
					setResults(json.results);
					setMsg({
						type: "notice",
						text: json.text,
					});
				}
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handleMatch = async (id) => {
		handleSubmit(null, id);
	};

	const handleClick = () => {
		formElement.current.registrationStr.value = "";
		setNames({});
		setDetails({});
		setMsg({});
	};

	const handleAllocationsUpdate = (summaryGolf, summarySporting) => {
		setDetails((prev) => ({
			...prev,
			summary: {
				...prev.summary,
				golf: summaryGolf,
				sporting: summarySporting,
			},
		}));
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div id="left-column">
						<Hdg section="Registration Snapshot" admin={true} />

						<p>
							Use this form to view submitted BFC registration details and
							current invoice.
						</p>

						<div className="spacer"></div>

						<form
							ref={formElement}
							method="post"
							action="/"
							onSubmit={(e) => handleSubmit(e)}
							className="well"
						>
							<div className="form-group">
								<Input
									name="registrationStr"
									label="Registration ID / Organization Name"
									reqd={true}
									value={names.registrationStr || ""}
									update={handleUpdate}
									errors={errors}
									note="Note: Use partial company name if exact match is not found"
								/>

								<div className="empty" />
							</div>

							<div className="msg-submit" style={{ marginTop: "30px" }}>
								{msg.type && <Msg data={msg} />}

								<div
									className={
										msg.type === "working" ||
										msg.type === "notice" ||
										msg.type === "success"
											? "hidden"
											: "submit-container"
									}
								>
									<Submit submit="Locate Registration" />
								</div>
							</div>

							<div className="results-container">
								{results.map((item) => {
									return (
										<button
											type="button"
											className="naked"
											key={item.id}
											onClick={(e) => handleMatch(item.id)}
										>
											{`${item.id} ${item.name}`}
										</button>
									);
								})}
							</div>
						</form>

						{details.id && (
							<>
								<div className="reset-container">
									<button type="button" className="naked" onClick={handleClick}>
										<i className="fa fa-times-circle-o fa-lg working" />
									</button>
								</div>

								<table className="approved assigned">
									<thead>
										<tr>
											<th colSpan="4" className="hdg">
												{`${details.level.name} - ID ${details.id}`}
											</th>
										</tr>
										<tr>
											<td style={{ width: "33%" }}>Name</td>
											<td style={{ width: "34%" }}>Organization</td>
											<td style={{ width: "33%" }}>Email</td>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td className="center">{details.name}</td>
											<td className="center">{details.organization}</td>
											<td className="center">
												<a href={`mailto:${details.email}`}>{details.email}</a>
											</td>
										</tr>
										<tr>
											<td
												className="center"
												colSpan="3"
												style={{
													paddingTop: "12.5px",
													paddingBottom: "12.5px",
												}}
											>
												<a
													href={details.dashboardUrl}
													target="_blank"
													rel="noopener noreferrer"
												>
													Sponsor Dashboard Access&nbsp;&nbsp;
													<i className="fa fa-external-link" />
												</a>
											</td>
										</tr>
									</tbody>
								</table>

								<table className="approved assigned">
									<thead>
										<tr>
											<th colSpan="4" className="hdg">
												Accepted Guest Summary
											</th>
										</tr>
										<tr>
											<td className="center" style={{ width: "25%" }}>
												Golf
											</td>
											<td className="center" style={{ width: "25%" }}>
												Sporting Clays
											</td>
											<td className="center" style={{ width: "25%" }}>
												Welcome Party
											</td>
											<td className="center" style={{ width: "25%" }}>
												Gift Package
											</td>
										</tr>
									</thead>

									<tbody>
										<tr>
											<td className="center">{details.summary.golf}</td>
											<td className="center">{details.summary.sporting}</td>
											<td className="center">{details.summary.welcome}</td>
											<td className="center">{details.summary.gift}</td>
										</tr>

										<tr>
											<td
												className="left"
												colSpan="4"
												style={{
													padding: "0",
												}}
											>
												<AllocationsForm
													registrationId={details.id}
													total={details.level.golf}
													golf={getAllocation(details.summary.golf)}
													sporting={getAllocation(details.summary.sporting)}
													handleAllocationsUpdate={handleAllocationsUpdate}
												/>
											</td>
										</tr>
									</tbody>
								</table>

								<table
									className="approved"
									style={{ marginTop: "25px", marginBottom: "5px" }}
								>
									<thead>
										<tr>
											<th className="left" style={{ width: "75%" }}>
												Item Description
											</th>
											<th>Amount</th>
										</tr>
									</thead>
									<tbody>
										{details.items.map((item) => {
											return (
												<tr key={item.id}>
													<td className="left">
														{item.id === "tickets"
															? `${item.qty} ${item.name}`
															: `${item.name}`}
													</td>
													<td className="right">
														{fmtCurrency((item.qty * item.amt) / 100)}
													</td>
												</tr>
											);
										})}
									</tbody>
									<tfoot>
										<tr>
											<th
												className="right"
												style={{ padding: "10px", fontSize: "1.15rem" }}
											>
												TOTAL
											</th>
											<th
												className="right"
												style={{
													padding: "12.5px 7.5px 12.5px 10px",
													fontSize: "1.15rem",
												}}
											>
												{details.totals.total}
											</th>
										</tr>
										<tr>
											<td className="right" style={{ paddingRight: "10px" }}>
												Payments Received
											</td>
											<td className="right">({details.totals.paid})</td>
										</tr>
										<tr>
											<td className="right" style={{ paddingRight: "10px" }}>
												Amount Due
											</td>
											<td className="right">{details.totals.due}</td>
										</tr>
									</tfoot>
								</table>

								<div className="homebutton">
									<a
										href={`https://valerotexasopen.com/benefit-for-children/invoiceprint/?${details.printId}`}
										target="_blank"
										rel="noopener noreferrer"
									>
										<i className="fa fa-print" /> &nbsp;Printable Invoice
										<i className="fa fa-angle-right" />
									</a>
								</div>
							</>
						)}

						<div className="spacer"></div>
					</div>

					<div id="right-column">
						<Nav on={2} user={user} />
					</div>
				</>
			)}
		</>
	);
};

export default Snapshot;

function getAllocation(str) {
	const split = str.split(" / ");

	return parseInt(split[1], 10);
}
